export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.announcement.status.draft': '草稿',
  'pages.announcement.status.scheduled': '待定時發布',
  'pages.announcement.status.publishing': '發布中',
  'pages.announcement.status.published': '已發布',
  'pages.announcement.status.publish_failed': '發布失敗',
  'pages.announcement.status.revoked': '已撤回',
  'pages.announcement.audience.memberLabel': '指定成員',
  'pages.announcement.audience.selectMembers': '請選擇成員',
  'pages.announcement.fields.status': '狀態',
  'pages.announcement.fields.publishTime': '發布時間',
  'pages.announcement.fields.audience': '投放範圍',
  'pages.announcement.fields.summary': '摘要',
  'pages.announcement.fields.revokeReason': '撤回原因',
  'pages.announcement.fields.content': '公告正文',
  'pages.announcement.fields.attachments': '附件',
  'pages.announcement.admin.title': '公告管理',
  'pages.announcement.admin.columns.title': '公告標題',
  'pages.announcement.admin.columns.creator': '建立人',
  'pages.announcement.admin.columns.publishTimeRange': '發布時間範圍',
  'pages.announcement.admin.columns.actions': '操作',
  'pages.announcement.admin.search.titlePlaceholder': '請輸入標題關鍵字',
  'pages.announcement.admin.search.creatorPlaceholder': '請輸入建立人',
  'pages.announcement.admin.pendingPublish': '待發布',
  'pages.announcement.admin.revokeReason': '後台手動撤回',
  'pages.announcement.admin.empty': '暫無公告，請點擊右上角建立第一則公告',
  'pages.announcement.admin.dispatchModalTitleWithName': '{title} 的發布記錄',
  'pages.announcement.detail.title': '公告詳情',
  'pages.announcement.detail.notFound': '公告不存在',
  'pages.announcement.detail.backToList': '返回列表',
  'pages.announcement.detail.edit': '編輯',
  'pages.announcement.detail.revoke': '撤回',
  'pages.announcement.detail.revokeReason': '詳情頁手動撤回',
  'pages.announcement.detail.revokeSuccess': '公告已撤回',
  'pages.announcement.detail.dispatchRecords': '發布記錄',
  'pages.announcement.create.title': '新增公告',
  'pages.announcement.create.scheduleSuccess': '公告已設定定時發布',
  'pages.announcement.create.publishSuccess': '公告已提交發布',
  'pages.announcement.edit.title': '編輯公告',
  'pages.announcement.edit.updateSuccess': '公告已更新',
  'pages.announcement.form.statusReason': '目前公告存在狀態說明',
  'pages.announcement.form.title': '公告標題',
  'pages.announcement.form.titlePlaceholder': '請輸入公告標題',
  'pages.announcement.form.titleRequired': '請輸入公告標題',
  'pages.announcement.form.summary': '公告摘要',
  'pages.announcement.form.summaryPlaceholder':
    '請輸入摘要，前台卡片會優先顯示摘要',
  'pages.announcement.form.content': '公告正文',
  'pages.announcement.form.contentPlaceholder': '請輸入公告正文',
  'pages.announcement.form.contentRequired': '請輸入公告正文',
  'pages.announcement.form.pinned': '置頂顯示',
  'pages.announcement.form.pinnedOn': '置頂',
  'pages.announcement.form.pinnedOff': '一般',
  'pages.announcement.form.publishMode': '發布時間',
  'pages.announcement.form.publishModeRequired': '請選擇發布時間類型',
  'pages.announcement.form.scheduledAt': '定時發布時間',
  'pages.announcement.form.scheduledAtRequired': '請選擇定時發布時間',
  'pages.announcement.form.scheduledAtFuture': '定時發布時間必須晚於目前時間',
  'pages.announcement.form.audiences': '投放範圍',
  'pages.announcement.form.audiencesRequired': '請至少新增一個投放範圍',
  'pages.announcement.form.memberRequired': '請選擇成員',
  'pages.announcement.form.saveDraft': '儲存草稿',
  'pages.announcement.form.saveDraftSuccess': '草稿已儲存',
  'pages.announcement.form.publishScheduled': '定時發布',
  'pages.announcement.form.publishNow': '立即發布',
  'pages.announcement.form.submitTip':
    '儲存草稿不會觸發消息中心。立即發布和定時發布都會依後端規則處理。',
  'pages.announcement.form.cancel': '取消',
  'pages.announcement.center.title': '公告中心',
  'pages.announcement.center.columns.title': '標題',
  'pages.announcement.center.columns.readStatus': '已讀狀態',
  'pages.announcement.center.columns.pinned': '是否置頂',
  'pages.announcement.center.columns.organization': '發布組織',
  'pages.announcement.center.columns.attachmentStatus': '附件狀態',
  'pages.announcement.center.search.titlePlaceholder': '請輸入標題關鍵字',
  'pages.announcement.center.read.read': '已讀',
  'pages.announcement.center.read.unread': '未讀',
  'pages.announcement.center.boolean.yes': '是',
  'pages.announcement.center.boolean.no': '否',
  'pages.announcement.center.boolean.none': '無',
  'pages.announcement.center.attachment.has': '含附件',
  'pages.announcement.center.attachment.none': '無附件',
  'pages.announcement.center.emptySummary': '暫無摘要',
  'pages.announcement.center.viewDetail': '查看詳情',
  'pages.announcement.center.empty': '暫無可查看公告',
  'pages.announcement.center.detail.title': '公告詳情',
  'pages.announcement.center.detail.backToCenter': '返回公告中心',
  'pages.announcement.center.detail.content': '正文',
  'pages.announcement.center.detail.loadFailed': '公告載入失敗',
  'pages.announcement.center.detail.retry': '重試',
  'pages.announcement.permission.queryRequired': '目前帳號沒有查詢權限',
  'pages.announcement.dispatch.columns.type': '發布方式',
  'pages.announcement.dispatch.columns.status': '消息中心狀態',
  'pages.announcement.dispatch.columns.errorMessage': '失敗原因',
  'pages.announcement.dispatch.columns.response': '返回摘要',
  'pages.announcement.dispatch.status.pending': '待派發',
  'pages.announcement.dispatch.status.processing': '處理中',
  'pages.announcement.dispatch.status.success': '成功',
  'pages.announcement.dispatch.status.failed': '失敗',
  'pages.announcement.dispatch.malformedResponse': '歷史返回摘要格式異常',
  'pages.announcement.dispatch.expand': '展開',
  'pages.announcement.attachment.uploadSuccess': '{name} 上傳成功',
  'pages.announcement.attachment.uploadFailed': '附件上傳失敗，請重試',
  'pages.announcement.attachment.fileTooLarge': '單個附件不能超過 20MB',
  'pages.announcement.attachment.selectFiles': '選擇附件',
  'pages.announcement.attachment.empty': '暫無附件',
  'pages.announcement.attachment.delete': '刪除',
  'pages.announcement.attachment.retry': '重試',
  'pages.announcement.attachment.uploadCompleted': '上傳完成',
  'pages.announcement.attachment.missingFileKey':
    '附件缺少檔案標識，暫時無法下載',
  'pages.announcement.attachment.downloadUrlMissing': '後端未返回下載地址',
  'pages.announcement.attachment.downloadFailed': '取得下載地址失敗',
  'pages.announcement.attachment.download': '下載',
};
